import { Services, isValidEmail, isValidPassword, regExp } from '@sigma-frontend-libs/commons'

import { isValidPhone, isValidUserName, permissionPresets, proxy, validation } from '@/utils'

import render from './render'

export default {
  name: 'UsersBasicForm',

  mixins: [
    proxy({ type: 'object' }),
    validation
  ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isNew: Boolean,
    isAccount: Boolean,

    saveSuccessKey: {
      type: Number,
      default: 0
    }
  },

  computed: {
    canUpdateUsers() {
      return this.checkPermissions(`advanced.${Services.users}.update`, permissionPresets.resellerUp)
    },

    // NOTE: https://tracker.yandex.ru/ONLINE-123
    canGetAndUpdateUsedReferralCode() {
      return this.checkPermissions(`advanced.${Services.users}.update`) || this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.managerUp)
    },

    // NOTE: https://tracker.yandex.ru/ONLINE-305
    canSetHasContract() {
      return this.checkPermissions(`advanced.${Services.users}.setHasContract`)
    },

    usernameMask() {
      if (this.isNew) {
        return regExp.usernameSoftForRegistration
      }

      return regExp.usernameSoft
    },

    classModifier() {
      switch (true) {
        case this.isNew: return 'new'
        case this.isAccount: {
          if (this.canUpdateUsers) {
            return 'basic'
          }

          return 'account'
        }
        default: return 'basic'
      }
    },

    validation() {
      const hasPassword = Boolean(this.proxy.password)

      if (!this.proxy.username || !isValidUserName(this.proxy.username)) {
        return false
      }
      if (this.isNew) {
        if (!hasPassword || !isValidPassword(this.proxy.password)) {
          return false
        }
      } else if (hasPassword && !isValidPassword(this.proxy.password)) {
        return false
      }
      if (!this.proxy.data.email || !isValidEmail(this.proxy.data.email)) {
        return false
      }
      if (!this.proxy.data.phone || !isValidPhone(this.proxy.data.phone)) {
        return false
      }

      return true
    }
  },

  render
}
